module.exports = {};


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-core/~/core-js/modules/$.iterators.js
 ** module id = 44
 ** module chunks = 0
 **/